import { CommonModule } from "@angular/common";
import { Component, Inject, ViewChild } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import * as L from "leaflet";
import { AgendaMapComponent } from "../../agenda-view/agenda-map/agenda-map.component";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";

@Component({
  selector: "app-modal-monitor-realtime",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressBarModule,
    MatIconModule,
    MatCardModule,
    MatSortModule,
    MatTableModule,
    AgendaMapComponent,
    DecimalFormatPipe,
  ],
  templateUrl: "./modal-monitor-realtime.component.html",
  styleUrl: "./modal-monitor-realtime.component.scss",
})
export class ModalMonitorRealtimeComponent {
  @ViewChild(AgendaMapComponent) agendaMap!: AgendaMapComponent;
  public dataSourceVisit: MatTableDataSource<any>;
  public displayColumsVisit: string[] = [
    "material",
    "price",
    "cntLoad",
    "noDelivery",
  ];

  public orderSelect;
  public isVisibleMap: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<ModalMonitorRealtimeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public toggleOrder(item) {
    if (this.orderSelect && this.orderSelect._id === item._id) {
      this.orderSelect = null;
      this.actualizarMapa();
    } else {
      this.orderSelect = item;
      this.dataSourceVisit = new MatTableDataSource(this.orderSelect?.items);
      this.actualizarMapa(item.serial);
    }
  }

  public onMapVisible() {
    this.isVisibleMap = !this.isVisibleMap;
  }

  actualizarMapa(id?: string) {
    if (id) {
      const visit = this.data.visits.filter((item) => {
        // Asegurarse de que `serials` es una cadena y dividirla en un array
        const serials = item.serials.split(", ").map((serial) => serial.trim());

        // Verificar si algún serial coincide con algún valor en document.serial
        const match = serials.some((serial) => id.includes(serial));

        return match; // Filtrar por los elementos que tengan alguna coincidencia
      });
      this.agendaMap.updateMap(visit);
    } else {
      this.agendaMap.updateMap(this.data.visits);
    }
  }
}

/*
Abierta = 2 
En Espera = 1, 3, 6
Cargando = 4 
En Tránsito = 7
Liquidación = 9 
Cerrada = 0, 5

*/

/*
Activo =  (   1  ) heroicons_solid:check-circle  - rgb(65, 106, 218)
Anulado =  (   0   )   heroicons_solid:x-circle  - rgb(141, 19, 19)
En progreso = ( 2, 3 , 4 , 6   )   heroicons_solid:play-circle - rgb(236, 199, 58)
Aprobado =  (   7   )  heroicons_solid:x-circle  - rgb(9, 133, 50)
Liquidación = (     9  )  heroicons_solid:check-circle
Rechazado = (     11 , 8 )    heroicons_solid:x-circle  - rgb(255, 0, 0)

*/
